import { useEffect, useMemo, useState } from 'react';
import { useChat } from '../../chat/ChatProvider';

/**
 * 「正在輸入…」提示；依 TYPING_UPDATED expiresAt 自動消失。
 */
export default function TypingIndicator({ conversationId }) {
  const { state, myMemberId } = useChat();
  const [, setTick] = useState(0);

  const map = state.typingByConversation[String(conversationId)] || {};
  const activeIds = useMemo(() => {
    const now = Date.now();
    return Object.entries(map)
      .filter(([mid, exp]) => String(mid) !== String(myMemberId) && Number(exp) > now)
      .map(([mid]) => mid);
  }, [map, myMemberId, state.typingByConversation]);

  useEffect(() => {
    if (!activeIds.length) return undefined;
    const timer = setInterval(() => setTick((n) => n + 1), 1000);
    return () => clearInterval(timer);
  }, [activeIds.join(',')]);

  if (!activeIds.length) return null;

  const summaries = state.participantSummaries || {};
  const names = activeIds.map((id) => {
    const s = summaries[id] || summaries[Number(id)];
    return s?.displayName || s?.username || `用戶 ${id}`;
  });

  let label;
  if (names.length === 1) {
    label = `${names[0]} 正在輸入…`;
  } else if (names.length === 2) {
    label = `${names[0]}、${names[1]} 正在輸入…`;
  } else {
    label = `${names[0]} 等 ${names.length} 人正在輸入…`;
  }

  return (
    <div className="chat-typing" aria-live="polite">
      {label}
    </div>
  );
}
